module.exports = __webpack_public_path__ + "static/media/Audio unit 2.c2d4703b.jpg";